<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="50"
    height="50"
    viewBox="0 0 50 50"
    fill="none"
  >
    <circle
      cx="25"
      cy="25"
      r="18.75"
      stroke="url(#paint0_linear_12389_31694)"
      stroke-width="2.5"
    />
    <path
      d="M24.9999 39.0416C25.8514 39.0416 26.5416 38.3514 26.5416 37.5C26.5416 36.6485 25.8514 35.9583 24.9999 35.9583C24.1485 35.9583 23.4583 36.6485 23.4583 37.5C23.4583 38.3514 24.1485 39.0416 24.9999 39.0416Z"
      fill="url(#paint1_linear_12389_31694)"
      stroke="url(#paint2_linear_12389_31694)"
    />
    <path
      d="M25 33.3333V31.5484C25 30.0604 25.7436 28.6709 26.9817 27.8455L28.2285 27.0143C30.1162 25.7559 31.25 23.6373 31.25 21.3686V20.8333C31.25 17.3815 28.4518 14.5833 25 14.5833V14.5833C21.5482 14.5833 18.75 17.3815 18.75 20.8333V20.8333"
      stroke="url(#paint3_linear_12389_31694)"
      stroke-width="2.5"
    />
    <defs>
      <linearGradient
        id="paint0_linear_12389_31694"
        x1="6.25"
        y1="6.25"
        x2="43.8776"
        y2="43.6215"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.456596" stop-color="#DF252A" />
        <stop offset="1" stop-color="#A20004" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_12389_31694"
        x1="23.9583"
        y1="36.4583"
        x2="26.0487"
        y2="38.5345"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.456596" stop-color="#DF252A" />
        <stop offset="1" stop-color="#A20004" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_12389_31694"
        x1="23.9583"
        y1="36.4583"
        x2="26.0487"
        y2="38.5345"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.456596" stop-color="#DF252A" />
        <stop offset="1" stop-color="#A20004" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_12389_31694"
        x1="18.75"
        y1="14.5833"
        x2="36.0711"
        y2="26.0521"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.456596" stop-color="#DF252A" />
        <stop offset="1" stop-color="#A20004" />
      </linearGradient>
    </defs>
  </svg>
</template>

<style lang="scss" scoped>
svg {
  width: 3.125rem;
  height: 3.125rem;
}
</style>
